// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1331":"47e8bb6b","3659":"a5df5307","5941":"b04767db","8038":"ec488373","8859":"1f2987e2"}[chunkId] + ".chunk.css";
};